"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _NoFrameImage = require("./NoFrameImage");
Object.keys(_NoFrameImage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NoFrameImage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NoFrameImage[key];
    }
  });
});
